import { authHeaders, client } from '../../_shared/services/openapiClient';

type LegacyApiResult<T> = Promise<{ data?: T; error?: unknown }>;
const legacyClient = client as unknown as {
  GET: <T>(path: string, options?: unknown) => LegacyApiResult<T>;
  POST: <T>(path: string, options?: unknown) => LegacyApiResult<T>;
  PATCH: <T>(path: string, options?: unknown) => LegacyApiResult<T>;
};

export type UserBinder = {
  userBinderId?: string;
  memberId?: string | null;
  imageUrl?: string | null;
};
export type GetUserBindersResponse = UserBinder[];
export type SaveUserBinderResponse = UserBinder;
export type UpdateUserBinderResponse = UserBinder;
export type UserBinderMap = Record<string, UserBinder>;

type GetUserBindersApiResponse = {
  userBinders: UserBinder[];
};

type SaveUserBinderApiResponse = {
  userBinder: UserBinder;
};

type GetUserBindersParams = {
  artistId?: string;
  memberId?: string;
};

export async function getUserBinders({
  artistId,
  memberId
}: GetUserBindersParams = {}): Promise<GetUserBindersResponse> {
  const { data, error } = await legacyClient.GET<GetUserBindersApiResponse>(
    '/api/v1/user_binders',
    {
      params: {
        query: {
          artist_id: artistId || undefined,
          member_id: memberId || undefined
        }
      },
      headers: authHeaders()
    }
  );

  if (error) throw error;
  if (!data) throw new Error('Empty response from getUserBinders');

  return data.userBinders;
}

export function mapUserBindersByMemberId(userBinders: GetUserBindersResponse): UserBinderMap {
  return Object.fromEntries(
    userBinders
      .filter((userBinder) => !!userBinder?.memberId)
      .map((userBinder) => [userBinder.memberId, userBinder])
  );
}

export async function saveUserBinder(
  artistId: string,
  memberId: string,
  dataUrl: string,
  shouldUpdate = false
): Promise<SaveUserBinderResponse | UpdateUserBinderResponse> {
  const requestBody = {
    user_binder: {
      artist_id: artistId,
      member_id: memberId,
      data_url: dataUrl
    }
  };

  const { data, error } = shouldUpdate
    ? await legacyClient.PATCH<SaveUserBinderApiResponse>('/api/v1/user_binder', {
        body: requestBody,
        headers: authHeaders()
      })
    : await legacyClient.POST<SaveUserBinderApiResponse>('/api/v1/user_binder', {
        body: requestBody,
        headers: authHeaders()
      });

  if (error) throw error;
  if (!data) throw new Error('Empty response from saveUserBinder');

  return data.userBinder;
}
